"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarLogoComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const logo_v1_svg_1 = __importDefault(require("./../../common/toolbar/logo_v1.svg"));
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const ToolbarLogoComponent = ({}) => {
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    let url = AppRouting_1.PATH__HOME;
    if (currentProjectContext) {
        url = AppRouting_1.AppPathGenerator.Project.home(currentProjectContext.projectApiKey);
    }
    return React.createElement(antd_1.Row, { align: "middle", className: "logoContent" },
        React.createElement(antd_1.Col, null,
            React.createElement(react_router_dom_1.Link, { to: url },
                React.createElement("img", { src: logo_v1_svg_1.default, className: "logoImgHead", alt: "" }))));
};
exports.ToolbarLogoComponent = ToolbarLogoComponent;
